import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Layout from '@/views/layout/index.vue'
import Login from '@/views/login/index.vue'
import Register from '@/views/login/register.vue'
import Dashboard from '@/views/dashboard/index.vue'
import DataImport from '@/views/data/import.vue'
import UserManage from '@/views/user/manage.vue'
import CommissionSetting from '@/views/commission/setting.vue'
import TheaterManage from '@/views/theater/index.vue'
import TeamManage from '@/views/team/index.vue'

const routes = [
  { path: '/login', component: Login, meta: { noAuth: true } },
  { path: '/register', component: Register, meta: { noAuth: true } },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: Dashboard, meta: { title: '数据看板' } },
      { path: 'user/dashboard', component: Dashboard, meta: { title: '用户后台' } },
      { path: 'data/import', component: DataImport, meta: { title: '数据导入' } },
      { path: 'user/manage', component: UserManage, meta: { title: '账号管理' } },
      { path: 'commission/setting', component: CommissionSetting, meta: { title: '分成设置' } },
      { path: 'theater/manage', component: TheaterManage, meta: { title: '剧场名称管理' } },
      { path: 'team/manage', component: TeamManage, meta: { title: '团队分组管理' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (!to.meta.noAuth && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
